import { AlertSeverity } from '../enums/alert-severity';

export class Alert {
  public constructor(
    public readonly title: string,
    public readonly content: string,
    public readonly severity: AlertSeverity,
    public readonly closeable: boolean,
  ) {}
}
